var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperAirplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_195_160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4282 23.3524C31.3746 23.6958 30.9781 24.2794 29.8208 23.8674C28.6635 23.4554 23.6592 21.4071 21.3017 20.4344L17.2832 25.5059V29.1886C17.3904 29.7608 17.8619 30.5961 18.8906 29.3603C19.9193 28.1244 22.6411 24.6112 23.8735 23.0091L32.3926 26.6138C32.8748 26.8427 33.8393 27.0258 33.8393 25.9272C33.8393 24.8287 33.9464 11.0507 34 4.29912C33.8393 3.95582 33.2928 3.40653 32.3926 3.95582C32.1354 4.09314 31.7375 4.29912 31.5706 4.38495C31.5377 8.91197 31.4681 18.1119 31.4282 23.3524Z",
    fill: "url(#paint0_linear_195_160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4282 23.3524C31.3746 23.6958 30.9781 24.2794 29.8208 23.8674C28.6635 23.4554 23.6592 21.4071 21.3017 20.4344L17.2832 25.5059V29.1886C17.3904 29.7608 17.8619 30.5961 18.8906 29.3603C19.9193 28.1244 22.6411 24.6112 23.8735 23.0091L32.3926 26.6138C32.8748 26.8427 33.8393 27.0258 33.8393 25.9272C33.8393 24.8287 33.9464 11.0507 34 4.29912C33.8393 3.95582 33.2928 3.40653 32.3926 3.95582C32.1354 4.09314 31.7375 4.29912 31.5706 4.38495C31.5377 8.91197 31.4681 18.1119 31.4282 23.3524Z",
    fill: "#38BAD3",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4282 23.3524C31.3746 23.6958 30.9781 24.2794 29.8208 23.8674C28.6635 23.4554 23.6592 21.4071 21.3017 20.4344L17.2832 25.5059V29.1886C17.3904 29.7608 17.8619 30.5961 18.8906 29.3603C19.9193 28.1244 22.6411 24.6112 23.8735 23.0091L32.3926 26.6138C32.8748 26.8427 33.8393 27.0258 33.8393 25.9272C33.8393 24.8287 33.9464 11.0507 34 4.29912C33.8393 3.95582 33.2928 3.40653 32.3926 3.95582C32.1354 4.09314 31.7375 4.29912 31.5706 4.38495C31.5377 8.91197 31.4681 18.1119 31.4282 23.3524Z",
    fill: "#38B5A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71002 15.7998C5.17422 15.5137 4.42411 14.7699 5.71002 14.0833C6.99592 13.3967 22.6411 5.10016 30.303 1.03773C30.7852 0.866085 31.5889 1.31238 31.5889 1.72434C31.5889 1.82954 31.5819 2.83246 31.5706 4.38495C31.5377 8.91197 31.4681 18.1119 31.4282 23.3524C31.3746 23.6958 30.9781 24.2794 29.8208 23.8674C28.6635 23.4554 23.6592 21.4071 21.3017 20.4344L17.2832 25.5059L15.9973 27.1288C15.6758 27.3004 14.9686 27.4378 14.7114 26.6138V19.9818L14.5506 19.9194C13.0504 19.5761 9.69634 18.8208 8.28184 18.5462C7.12452 17.4476 8.01394 16.7153 8.60331 16.4864L8.65115 16.4728L5.71002 15.7998ZM29.6601 21.9792L29.8208 5.15738L22.2661 18.8895L29.6601 21.9792Z",
    fill: "url(#paint1_linear_195_160)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71002 15.7998C5.17422 15.5137 4.42411 14.7699 5.71002 14.0833C6.99592 13.3967 22.6411 5.10016 30.303 1.03773C30.7852 0.866085 31.5889 1.31238 31.5889 1.72434C31.5889 1.82954 31.5819 2.83246 31.5706 4.38495C31.5377 8.91197 31.4681 18.1119 31.4282 23.3524C31.3746 23.6958 30.9781 24.2794 29.8208 23.8674C28.6635 23.4554 23.6592 21.4071 21.3017 20.4344L17.2832 25.5059L15.9973 27.1288C15.6758 27.3004 14.9686 27.4378 14.7114 26.6138V19.9818L14.5506 19.9194C13.0504 19.5761 9.69634 18.8208 8.28184 18.5462C7.12452 17.4476 8.01394 16.7153 8.60331 16.4864L8.65115 16.4728L5.71002 15.7998ZM29.6601 21.9792L29.8208 5.15738L22.2661 18.8895L29.6601 21.9792Z",
    fill: "#38BAD3",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8208 5.15738L29.6601 21.9792L22.2661 18.8895L29.8208 5.15738Z",
    fill: "url(#paint2_linear_195_160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8208 5.15738L29.6601 21.9792L22.2661 18.8895L29.8208 5.15738Z",
    fill: "#38BAD3",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8208 5.15738L29.6601 21.9792L22.2661 18.8895L29.8208 5.15738Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7114 26.6138C14.9686 27.4378 15.6758 27.3004 15.9973 27.1288L17.2832 25.5059M14.7114 26.6138C14.7114 25.9789 14.7114 22.6526 14.7114 19.9818M14.7114 26.6138V19.9818M29.8208 5.15738C29.758 11.7267 29.7228 15.4099 29.6601 21.9792M29.8208 5.15738C26.8705 10.5201 25.2164 13.5268 22.2661 18.8895M29.8208 5.15738L29.6601 21.9792M29.8208 5.15738L22.2661 18.8895M29.6601 21.9792L22.2661 18.8895M14.7114 19.9818C14.7114 19.1869 14.7114 18.4501 14.7114 17.8596L8.65115 16.4728M14.7114 19.9818L14.5506 19.9194C13.0504 19.5761 9.69634 18.8208 8.28184 18.5462C7.12452 17.4476 8.01394 16.7153 8.60331 16.4864L8.65115 16.4728M17.2832 25.5059L21.3017 20.4344C23.6592 21.4071 28.6635 23.4554 29.8208 23.8674C30.9781 24.2794 31.3746 23.6958 31.4282 23.3524C31.4681 18.1119 31.5377 8.91197 31.5706 4.38495M17.2832 25.5059V29.1886C17.3904 29.7608 17.8619 30.5961 18.8906 29.3603C19.9193 28.1244 22.6411 24.6112 23.8735 23.0091L32.3926 26.6138C32.8748 26.8427 33.8393 27.0258 33.8393 25.9272C33.8393 24.8287 33.9464 11.0507 34 4.29912C33.8393 3.95582 33.2928 3.40653 32.3926 3.95582C32.1354 4.09314 31.7375 4.29912 31.5706 4.38495M31.5706 4.38495C31.5819 2.83246 31.5889 1.82954 31.5889 1.72434C31.5889 1.31238 30.7852 0.866085 30.303 1.03773C22.6411 5.10016 6.99592 13.3967 5.71002 14.0833C4.42411 14.7699 5.17422 15.5137 5.71002 15.7998L8.65115 16.4728M8.28184 14.5982L15.3543 16.3147L26.2845 5.15738L8.28184 14.5982Z",
    stroke: "black",
    strokeOpacity: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_195_160",
    x: 0.5,
    y: 0.499748,
    width: 38.001,
    height: 38.0003,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_195_160"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_195_160",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_195_160",
    x1: 32.0711,
    y1: 2.5826,
    x2: 13.7769,
    y2: 28.7734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38B5A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25BAD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_195_160",
    x1: 32.0711,
    y1: 2.5826,
    x2: 13.7769,
    y2: 28.7734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38B5A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25BAD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_195_160",
    x1: 32.0711,
    y1: 2.5826,
    x2: 13.7769,
    y2: 28.7734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38B5A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25BAD3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperAirplane);
export default __webpack_public_path__ + "static/media/PaperAirplane.cf3d666cee0f0c9d3336cd82e7231122.svg";
export { ForwardRef as ReactComponent };